define('plugin/telegram-notifications/view/TelegramNotificationsView',['require','lib/view/LayoutView','Config','plugin/telegram-notifications/view/TelegramNotificationsCodeView','lib/view/ModalRegion'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');
    var TelegramNotificationsCodeView = require('plugin/telegram-notifications/view/TelegramNotificationsCodeView');
    var ModalRegion = require('lib/view/ModalRegion');
    /**
     *
     * @class TelegramNotificationsView
     */
    return LayoutView.extend({

        template: '#telegram_subscribe_view',

        ui: {
             subscribeBtn: '.btn-telegram-subscribe',
            // pushSuccessBlock: '.push-success'
        },

        regions: {
            'notification': '#sb_telegram_notification',
        },

        events: {
            'click @ui.subscribeBtn' : 'onSubscribe'
        },

        _bodyClass: 'has-push-alert',

        _clientModel : null,

        initialize: function () {
            this._clientModel = this.getOption('clientModel');

            this.initPushNotifyObj();
            LayoutView.prototype.initialize.apply(this);
        },

        onBeforeShow : function () {
            //console.log(this.ui.subscribeBtn);
        },


        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            // if(this.pushNotifySubscribed !== null) {
            //     data.is_subcribed = this.pushNotifySubscribed;
            // }
            // this._addBodyClass(!data.is_subcribed);

            data.is_logged_in = this._clientModel.get('is_logged_in');

            return data;
        },

        onSubscribe : function () {
            var _this = this;
            var region = new ModalRegion();

            //console.log(this.model);
            this.model.fetch();
            var view = new TelegramNotificationsCodeView({
                model: this.model,
                clientModel: this._clientModel,
            });

            this.listenTo(view, 'ok', function () {
                region.hide();
            });

            this.listenTo(view, 'code:expired', function () {
                region.hide();
            });

            region.show(view);

        },

        _performSubscribe : function(){

        },

        initPushNotifyObj : function () {

        },

        //Igor ask to add class
        _addBodyClass : function (add){
            if(add){
                jQuery('body').addClass(this._bodyClass);
            } else{
                jQuery('body').removeClass(this._bodyClass);
            }
        },

    });

});
